import styled from 'styled-components'

export const Modal = styled.div`
  position: absolute;
  border-radius: 0.3125em;
  background-color: transparent;
  border: 0;
  left: -885px;

  animation: fade-in 0.3s ease;

  @keyframes fade-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export const Seta = styled.div`
  width: 0;
  height: 0;
  border-top: 0.9375em solid transparent;
  border-left: 0.7em solid transparent;
  border-right: 0.7em solid transparent;
  border-bottom: 0.6em solid ${({ theme }) => theme.cor42}!important;
  position: relative;
  left: 940px;
`

export const Conteudo = styled.div`
  display: grid;
  padding: 24px;
  gap: 16px;
  min-width: 1545px;
  min-height: 922px;
  background-color: ${({ theme }) => theme.cor42}!important;
  border-radius: 8px;

  /* Telas Full HD com zoom 110% / 125% */
  @media screen and (max-width: 1746px) {
    min-width: unset;
    min-height: unset;
    width: 100vw;
    height: 100vh;
  }
`

export const TituloWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: 16px;
`

export const Titulo = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 16px;
`

export const TituloModal = styled.h1`
  font-family: RobotoRegular;
  margin: 0;
  font-weight: 100;
  font-size: 24px;
  color: ${({ theme }) => theme.cor9};
`

export const Elipse = styled.img`
  height: 14px;
  width: 14px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.cor11};
`

export const BotoesFiltroWrapper = styled.div`
  display: flex;
  gap: 24px;
  justify-content: flex-end;
`

export const LimparFiltroLabelWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const Grupo = styled.div`
  display: flex;
  align-items: flex-start;
  min-height: 185px;
  height: max-content;
  border-radius: 8px;
  padding: 16px;
  gap: 30px;
  background-color: ${({ theme }) => theme.cor40}!important;
  justify-content: space-between;
`

export const GruposWrapper = styled.div`
  display: grid;
  gap: 16px;

  @media screen and (max-width: 1746px) {
    overflow: auto;
    padding-right: 10px;
  }
`
